import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ShortNamePipe } from '../helpers/short-name.pipe';
import { PagingComponent } from './components/paging/paging.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { AssesmentComponent } from './components/assesment/assesment.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDatepickerComponent } from './components/ngb-datepicker/ngb-datepicker.component';
import { RouterModule } from '@angular/router';
import { ArabicNumbersDirective } from '../helpers/arabic-num.directive';
import { NoArabicDirective } from '../helpers/arabic-letters.directive';
import { ImageControlComponent } from './components/image-control/image-control.component';
import { CropperDialogComponent } from './components/image-control/cropper-dialog/cropper-dialog.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ArabicToEnglishDirective } from '../helpers/arabic-numbers.pipe';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { DndDirective } from '../helpers/dnd.directive';
import { TimeAgoPipe } from '../helpers/time-ago.pipe';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { SafePipe } from '../helpers/SafePipe';
import { SignaturePadModule } from 'angular2-signaturepad';


registerLocaleData(localeAr);
@NgModule({
  declarations: [
    PagingComponent,
    EmptyStateComponent,
    AssesmentComponent,
    NgbDatepickerComponent,
    ImageControlComponent,
    CropperDialogComponent,
    FileManagerComponent
  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    TranslateModule.forChild({}),
    ReactiveFormsModule,
    ShortNamePipe,
    TimeAgoPipe,
    ArabicToEnglishDirective,
    ArabicNumbersDirective,
    NgbModule,
    NgSelectModule,
    NoArabicDirective,
    ImageCropperComponent,
    DndDirective,
    OnlynumberDirective,
    DropDownDirective,
    SafePipe,
    SignaturePadModule
  ],
  exports: [
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    ShortNamePipe,
    TimeAgoPipe,
    ArabicToEnglishDirective,
    ArabicNumbersDirective,
    PagingComponent,
    NgbModule,
    EmptyStateComponent,
    AssesmentComponent,
    NgSelectModule,
    NgbDatepickerComponent,
    NoArabicDirective,
    ImageControlComponent,
    CropperDialogComponent,
    FileManagerComponent,
    OnlynumberDirective,
    DropDownDirective,
    SafePipe,
    SignaturePadModule
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') || 'ar' },
  ]
})
export class SharedModule { }
